export default __webpack_public_path__ + "static/media/thumb.a8dea8fa.png";